import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import monitoringRoleManagement from '../../staticRoleManagement/monitoringRoleManagement'
import { MONITORING_ROUTE } from '../../staticRoleManagement/monitoringRoute'
import ChannelPushMonitoring from '../ChannelPushMonitoring'
import MonitoringAllocateMismatch from '../MonitoringAllocateMismatch'
import MonitoringInventoryHealth from '../MonitoringInventoryHealth'
import MonitoringPaymentFollowUps from '../MonitoringPaymentFollowUps'
import RequestsMonitoring from '../MonitoringRequests'
import MonitoringReserve from '../MonitoringReserve'
import MonitoringUpdate from '../MonitoringUpdate'
import useStyles from './styles/index.styles'

export default function MonitoringTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      value: 'requests',
      className: classes.tab,
      label: getTranslate('Requests'),
      component: LocalizedLink,
      to: '/monitoring/requests'
    },
    {
      value: 'reserves',
      className: classes.tab,
      label: getTranslate('Reservation'),
      component: LocalizedLink,
      to: '/monitoring/reserves'
    },
    {
      value: 'update',
      className: classes.tab,
      label: getTranslate('Update'),
      component: LocalizedLink,
      to: '/monitoring/update'
    },
    {
      value: 'push',
      className: classes.tab,
      label: getTranslate('Push'),
      component: LocalizedLink,
      to: '/monitoring/push'
    },
    {
      value: 'inventory-health',
      className: classes.tab,
      label: getTranslate('Inventory Health'),
      component: LocalizedLink,
      to: '/monitoring/inventory-health'
    },
    {
      value: 'allocate-mismatch',
      className: classes.tab,
      label: getTranslate('Allocate Mismatch'),
      component: LocalizedLink,
      to: '/monitoring/allocate-mismatch'
    },
    {
      value: 'payment-follow-ups',
      className: classes.tab,
      label: getTranslate('Payment Follow-ups'),
      component: LocalizedLink,
      to: '/monitoring/payment-follow-ups'
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = monitoringRoleManagement.find(
    (item) => item.route === MONITORING_ROUTE
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={tabItem.className}
              label={tabItem.label}
              to={tabItem.to}
              component={LocalizedLink}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="requests"
        dir={theme.direction}
        className={classes.tabPanel}>
        <RequestsMonitoring />
      </TabPanel>
      <TabPanel
        value={page}
        index="reserves"
        dir={theme.direction}
        className={classes.tabPanel}>
        <MonitoringReserve />
      </TabPanel>
      <TabPanel
        value={page}
        index="update"
        dir={theme.direction}
        className={classes.tabPanel}>
        <MonitoringUpdate />
      </TabPanel>
      <TabPanel
        value={page}
        index="push"
        dir={theme.direction}
        className={classes.tabPanel}>
        <ChannelPushMonitoring />
      </TabPanel>
      <TabPanel
        value={page}
        index="allocate-mismatch"
        dir={theme.direction}
        className={classes.tabPanel}>
        <MonitoringAllocateMismatch />
      </TabPanel>
      <TabPanel
        value={page}
        index="inventory-health"
        dir={theme.direction}
        className={classes.tabPanel}>
        <MonitoringInventoryHealth />
      </TabPanel>
      <TabPanel
        value={page}
        index="payment-follow-ups"
        dir={theme.direction}
        className={classes.tabPanel}>
        <MonitoringPaymentFollowUps />
      </TabPanel>
    </div>
  )
}
